import { CONFIG } from "@/config";
import { initializeApp } from "firebase/app";

const config = {
  apiKey: "AIzaSyC0Cd0Uzorus0z22BUhMbt2hhtag4wGB18",
  authDomain: CONFIG.AUTH_DOMAIN,
};
export const app = initializeApp(config);
